<div *ngIf="productInfo as productInfo else loading">
  <p-toolbar styleClass="">
    <ng-template pTemplate="left">
      <div class="grid">
        <div class="col-3">
          Начальная дата:
          <p-calendar [(ngModel)]="fromDate"
                      selectionMode="single"
                      [readonlyInput]="true"
                      showButtonBar="true"
                      selectOtherMonths="true"
                      hideOnDateTimeSelect="true"
                      [firstDayOfWeek]="1"
                      [maxDate]="toDate"
                      showWeek="true"
                      showClear="true"
                      dateFormat="dd/mm/yy"
                      inputId="filter-range-from"
                      inputStyleClass="p-dropdown-calendar-style"
                      styleClass="p-column-filter mt-1"
                      panelStyleClass="p-dropdown-filter-style"
                      (onSelect)="onDateRangeChangeFrom( $event)"
                      (onClearClick)="onDateRangeClearFrom( $event)"
                      (onTodayClick)="onTodayClickFrom( $event)">
          </p-calendar>
        </div>
        <div class="col-3">
          Конечная дата:
          <p-calendar [(ngModel)]="toDate"
                      selectionMode="single"
                      [readonlyInput]="true"
                      showButtonBar="true"
                      selectOtherMonths="true"
                      hideOnDateTimeSelect="true"
                      [firstDayOfWeek]="1"
                      [minDate]="fromDate"
                      showWeek="true"
                      showClear="true"
                      dateFormat="dd/mm/yy"
                      inputId="filter-range-to"
                      inputStyleClass="p-dropdown-calendar-style"
                      styleClass="p-column-filter mt-1"
                      panelStyleClass="p-dropdown-filter-style"
                      (onSelect)="onDateRangeChange( $event)"
                      (onClearClick)="onDateRangeClear( $event)"
                      (onTodayClick)="onTodayClick( $event)">
          </p-calendar>
        </div>
        <div class="col-6">
          Документы для поиска товаров:
          <p-multiSelect #dst [options]="docTypes"
                         placeholder="Все документы"
                         (onChange)="onDocTypeChange($event)"
                         (onSelectAllChange)="onAllDocTypeChange($event)"
                         [(ngModel)]="selectedDocTypes"
                         [showToggleAll]="true"
                         [selectAll]="selectAllTypes"
                         styleClass="p-column-filter p-dropdown-filter-style mt-1"
                         optionLabel="DOCNAME1" maxSelectedLabels="1"
                         selectedItemsLabel="{0} документов выбрано"
                         dataKey="DOCTYPEID">
          </p-multiSelect>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="right">
      <p-button icon="pi pi-refresh" label="Обновить" styleClass="p-button-success mr-2" (onClick)="reloadTable($event)"
                pTooltip="Обновить таблицу " tooltipPosition="top"></p-button>

      <p-button icon="pi pi-undo" label="Сбросить фильтр" styleClass="p-button-success mr-2" (onClick)="clearOrResetTableFilter($event)"
                pTooltip="Сбросить фильтр и вернуться в начало" tooltipPosition="top"></p-button>

      <p-button label="XLSX" icon="pi pi-file-excel" styleClass="p-button-info mr-2" (onClick)="onExportData()"
                pTooltip="Экспортировать информацию о товарах" tooltipPosition="top" [disabled]="!totalRecords"></p-button>
    </ng-template>
  </p-toolbar>

  <!--
             [loading]="loading"
  -->

  <p-table #dt
           [value]="productInfo"
             [loading]="contentLoading"
           [rows]="10"
           [rowsPerPageOptions]="[10,25,50]"
           [paginator]="true"
           [globalFilterFields]="['PRODCODE', 'DOCITEMPRODNAME', 'INVOICE', 'CUSTOMER_NICKNAME', 'CUSTOMER', 'ProductCategory']"
           [rowHover]="true"
           dataKey="DOCITEMID"
           currentPageReportTemplate="Показано {first} до {last} з {totalRecords} записів"
           [showCurrentPageReport]="true"
           selectionMode="single"
           [(selection)]="selectedRow"
           rowExpandMode="single"
           [resizableColumns]="true"
           [tableStyle]="{'width': '100%'}"
           styleClass="p-datatable p-datatable-gridlines p-datatable-striped">
    <!-- Caption with global filter -->
    <ng-template pTemplate="caption">
      <div class="flex align-items-center justify-content-between">
        <h5 class="m-0">Товары из счетов покупателя</h5>

        <p-checkbox [(ngModel)]="showProductExtentionColumn" [binary]="true" label="Расширенная информация по товару" class="col-3"></p-checkbox>
        <p-checkbox [(ngModel)]="showCustomerColumn" [binary]="true" label="Покупатель" class="col-2"></p-checkbox>
        <p-checkbox [(ngModel)]="showSellerColumn" [binary]="true" label="Продавец" class="col-2"></p-checkbox>

        <span class="p-input-icon-left">
          <i class="pi pi-search"></i>
          <input pInputText
                 type="text"
                 (input)="dt.filterGlobal($any($event.target).value, 'contains')"
                 placeholder="Пошук..." />
        </span>
      </div>
    </ng-template>

    <!-- Table Header -->
    <ng-template pTemplate="header">
      <tr>
        <!-- Product Information -->
        <th pResizableColumn pSortableColumn="PRODCODE" [frozen]="true" style="min-width: 150px;">
          Код товару
          <p-sortIcon field="PRODCODE"></p-sortIcon>
          <p-columnFilter type="text" field="PRODCODE" display="menu"></p-columnFilter>
        </th>
        <th pResizableColumn pSortableColumn="DOCITEMPRODNAME" style="min-width: 250px;">
          Найменування
          <p-sortIcon field="DOCITEMPRODNAME"></p-sortIcon>
          <p-columnFilter type="text" field="DOCITEMPRODNAME" display="menu"></p-columnFilter>
        </th>

        <!-- Category Information -->
        <th pResizableColumn pSortableColumn="ProductCategory" style="min-width: 120px;" *ngIf="showProductExtentionColumn">
          Категорія
          <p-sortIcon field="ProductCategory"></p-sortIcon>
          <p-columnFilter type="text" field="ProductCategory" display="menu"></p-columnFilter>
        </th>
        <th pResizableColumn pSortableColumn="PGROUPNAME" style="min-width: 120px;" *ngIf="showProductExtentionColumn">
          Група товару
          <p-sortIcon field="PGROUPNAME"></p-sortIcon>
          <p-columnFilter type="text" field="PGROUPNAME" display="menu"></p-columnFilter>
        </th>

        <!-- Pricing Information -->
        <th pResizableColumn pSortableColumn="DOCITEMPRICE" style="min-width: 100px;" class="text-right">
          Ціна (UAH)
          <p-sortIcon field="DOCITEMPRICE"></p-sortIcon>
          <p-columnFilter type="numeric" field="DOCITEMPRICE" display="menu"></p-columnFilter>
        </th>
        <th pResizableColumn pSortableColumn="DOCITEMVPRICE" style="min-width: 100px;" class="text-right" *ngIf="showProductExtentionColumn">
          Ціна ($)
          <p-sortIcon field="DOCITEMVPRICE"></p-sortIcon>
          <p-columnFilter type="numeric" field="DOCITEMVPRICE" display="menu"></p-columnFilter>
        </th>

        <!-- Quantity Information -->
        <th pResizableColumn pSortableColumn="ORDERED" style="min-width: 80px;" class="text-right">
          Замовлено
          <p-sortIcon field="ORDERED"></p-sortIcon>
          <p-columnFilter type="numeric" field="ORDERED" display="menu"></p-columnFilter>
        </th>
        <th pResizableColumn pSortableColumn="SHIPPED" style="min-width: 80px;" class="text-right">
          Відвантажено
          <p-sortIcon field="SHIPPED"></p-sortIcon>
          <p-columnFilter type="numeric" field="SHIPPED" display="menu"></p-columnFilter>
        </th>

        <!-- Document Information -->
        <th pResizableColumn pSortableColumn="INVOICE" style="min-width: 100px;">
          Документ
          <p-sortIcon field="INVOICE"></p-sortIcon>
          <p-columnFilter type="text" field="INVOICE" display="menu"></p-columnFilter>
        </th>
        <th pResizableColumn pSortableColumn="DOCDATE" style="min-width: 100px;">
          Дата
          <p-sortIcon field="DOCDATE"></p-sortIcon>
          <p-columnFilter type="date" field="DOCDATE" display="menu"></p-columnFilter>
        </th>

        <!-- Customer Information -->
        <th pResizableColumn pSortableColumn="CUSTOMER_NICKNAME" style="min-width: 120px;" *ngIf="showCustomerColumn">
          Клієнт
          <p-sortIcon field="CUSTOMER_NICKNAME"></p-sortIcon>
          <p-columnFilter type="text" field="CUSTOMER_NICKNAME" display="menu"></p-columnFilter>
        </th>
        <th pResizableColumn pSortableColumn="CUSTOMER" style="min-width: 150px;" *ngIf="showCustomerColumn">
          Повна назва
          <p-sortIcon field="CUSTOMER"></p-sortIcon>
          <p-columnFilter type="text" field="CUSTOMER" display="menu"></p-columnFilter>
        </th>

        <!-- Sales Information -->
        <th pResizableColumn pSortableColumn="SELLER" style="min-width: 150px;" *ngIf="showSellerColumn">
          Продавець
          <p-sortIcon field="SELLER"></p-sortIcon>
          <p-columnFilter type="text" field="SELLER" display="menu"></p-columnFilter>
        </th>
        <th pResizableColumn pSortableColumn="AUTHOR" style="min-width: 150px;" *ngIf="showSellerColumn">
          Автор
          <p-sortIcon field="AUTHOR"></p-sortIcon>
          <p-columnFilter type="text" field="AUTHOR" display="menu"></p-columnFilter>
        </th>

      </tr>
    </ng-template>

    <!-- Table Body -->
    <ng-template pTemplate="body" let-item>
      <tr [class.pending-shipment]="item.ORDERED > item.SHIPPED">
        <!-- Product Information -->
        <td [frozen]="true" style="font-weight: 500;">
          <a [routerLink]="['/edit-product', item.PRODID]">
            {{ item.PRODCODE }}
          </a>
        </td>
        <td>
          <div class="product-name" [title]="item.DOCITEMPRODNAME">
            {{ item.DOCITEMPRODNAME }}
          </div>
        </td>

        <!-- Category Information -->
        <td *ngIf="showProductExtentionColumn">
          <span class="category-badge">
            {{ item.ProductCategory }}
          </span>
        </td>
        <td *ngIf="showProductExtentionColumn">
          <span class="group-badge">
            {{ item.PGROUPNAME }}
          </span>
        </td>

        <!-- Pricing Information -->
        <td class="text-right">
          <span class="price-uah">
            {{ item.DOCITEMPRICE | number:'1.2-2' }} ₴
          </span>
        </td>
        <td class="text-right" *ngIf="showProductExtentionColumn">
          <span class="price-usd">
            {{ item.DOCITEMVPRICE | number:'1.2-2' }} $
          </span>
        </td>

        <!-- Quantity Information -->
        <td class="text-right">
          <span class="quantity-ordered">
            {{ item.ORDERED | number:'1.0-2' }}
          </span>
        </td>
        <td class="text-right">
          <span [class]="getShippedStatusClass(item)">
            {{ item.SHIPPED | number:'1.0-2' }}
          </span>
          <i *ngIf="item.ORDERED > item.SHIPPED"
             class="pi pi-exclamation-triangle ml-2"
             style="color: #ff6b6b;"
             [title]="'Не відвантажено: ' + (item.ORDERED - item.SHIPPED)"></i>
        </td>

        <!-- Document Information /* item.DOCTYPEID */-->
        <td>
          <a [routerLink]="['/edit-document', 1 , item.INVOICEID]">
            {{ item.INVOICE }}
          </a>
        </td>
        <td>
          {{ item.DOCDATE | date:'dd.MM.yyyy' }}
        </td>

        <!-- Customer Information -->
        <td *ngIf="showCustomerColumn">
          <div class="customer-info">
            <a [routerLink]="['/edit-client', item.CUSTOMERID]" class="customer-link">
              {{ item.CUSTOMER_NICKNAME }}
            </a>
          </div>
        </td>
        <td *ngIf="showCustomerColumn">
          <div class="customer-full-name" [title]="item.CUSTOMER">
            {{ item.CUSTOMER }}
          </div>
        </td>

        <!-- Sales Information -->
        <td *ngIf="showSellerColumn">
          <span class="seller-badge">
            {{ item.SELLER }}
          </span>
        </td>
        <td *ngIf="showSellerColumn">
          <div class="author-info">
            <i class="pi pi-user mr-2"></i>
            {{ item.AUTHOR }}
          </div>
        </td>

        <!-- Actions -->
        <!--<td>
          <div class="flex gap-2">
            <button pButton
                    pRipple
                    icon="pi pi-eye"
                    class="p-button-rounded p-button-text p-button-sm"
                    (click)="viewDetails(item)"
                    pTooltip="Переглянути деталі"></button>
            <button pButton
                    pRipple
                    icon="pi pi-pencil"
                    class="p-button-rounded p-button-text p-button-sm"
                    (click)="editItem(item)"
                    pTooltip="Редагувати"></button>
          </div>
        </td>-->
      </tr>
    </ng-template>

    <!-- Empty Message -->
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="15" class="text-center">
          <div class="empty-message">
            <i class="pi pi-inbox" style="font-size: 3rem; color: #dee2e6;"></i>
            <p>Записи не знайдено</p>
          </div>
        </td>
      </tr>
    </ng-template>

    <!-- Footer with totals -->
    <ng-template pTemplate="footer">
      <tr>
        <td class="text-right font-bold"></td>
        <td class="text-right font-bold" *ngIf="showProductExtentionColumn"></td>
        <td class="text-right font-bold" *ngIf="!showProductExtentionColumn">Всього:</td>
        <td class="text-right font-bold" *ngIf="showProductExtentionColumn"></td>
        <td class="text-right font-bold" *ngIf="showProductExtentionColumn">Всього:</td>
        <td class="text-right font-bold">
          {{ getTotalPrice() | number:'1.2-2' }} ₴
        </td>
        <td class="text-right font-bold">
          {{ getTotalVPrice() | number:'1.2-2' }} $
        </td>
        <td class="text-right font-bold">
          {{ getTotalOrdered() | number:'1.0-2' }}
        </td>
        <td class="text-right font-bold">
          {{ getTotalShipped() | number:'1.0-2' }}
        </td>
        <td ></td>
        <td *ngIf="showCustomerColumn"></td>
        <td *ngIf="showCustomerColumn"></td>
        <td *ngIf="showSellerColumn"></td>
        <td *ngIf="showSellerColumn"></td>
      </tr>
    </ng-template>

    <!-- Loading Template -->
    <ng-template pTemplate="loadingbody">
      <tr>
        <td colspan="14">
          <div class="flex align-items-center justify-content-center" style="height: 400px;">
            <i class="pi pi-spin pi-spinner" style="font-size: 3rem;"></i>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div class="card">
  </div>

</div>
<ng-template #loading>
  <p>Информация о товарах загружается...</p>
</ng-template>
